<ng-container *ngIf="data?.length">
    <div class="notification-container firefox-scrollbar-custom"
    infinite-scroll
    [infiniteScrollDistance]="1"
    [infiniteScrollUpDistance]="2"
    [infiniteScrollThrottle]="50"
    [scrollWindow]="false"
    (scrolled)="onScroll()">
        <ng-container *ngFor="let notification of data">
            <div class="date">
                <p>{{notification?.createdDate}}</p>
                <ng-container *ngFor="let item of notification?.items">
                    <div class="item" tabindex="1" [ngStyle]="{'cursor': 'pointer'}"
                        [title]="item?.message"
                        [ngClass]="{'unread': item?.readStatus === 'false'}" (click)="viewDetails(item)">
                        <div [ngClass]="{'unread': item?.readStatus === 'false'}" class="title text-truncate">{{item?.message}}</div>
                        <div class="time text-center">{{item?.createdAt | date: timeFormat }}</div>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>
</ng-container>
<div class="text-center mt-2" *ngIf="!loaded">
    <div class="spinner-border"></div>
</div>
<ng-container class="text-center" *ngIf="loaded && !data?.length">
    <div class="text-center px-3 pb-3">{{ 'No data' | translate}}</div>
</ng-container>
